import ShButton from '@/components/Helpers/ShButton';

export default {
  name: 'ConnectionChangeStatus',

  components: {
    ShButton,
  },

  props: {
    connection: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      newStatus: null,
    };
  },

  computed: {
    notifyStatuses() {
      const allStatuses = this.$store.getters['connections/connectionsSettings'].notifyStatuses;
      const canBeChangedTo = ((allStatuses
        .find(notify => notify.status_name === this.connection.notify_status))
        .can_change_to_status_id)
        .split(',');

      return allStatuses.filter(notify => canBeChangedTo.includes(String(notify.id)));
    },
    newStatusDescription() {
      return (this.notifyStatuses.find(notify => notify.status_name === this.newStatus)).description;
    },
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'connections/update',
      ]);
    },
  },

  methods: {
    async addNoteToConnection() {
      const params = {
        note: `Zmiana statusu na: ${this.newStatusDescription} `,
        connection_id: this.connection.id,
      };
      await this.$store.dispatch('connections/notes/create', params);
      this.$store.dispatch('connections/notes/getList', this.connection.id);
    },
    async handleChangeStatus() {
      const params = {
        id: this.connection.id,
        notify_status: this.newStatus,
      };
      await this.$store.dispatch('connections/update', params);
      this.addNoteToConnection();
      this.$notify.success({
        title: 'Zmiana statusu',
        message: `Zmieniono status połączenia na: ${this.newStatusDescription}`,
        customClass: 'callmeweb-notification',
      });
      const updatedConnection = {
        ...this.connection,
        ...params,
      };
      this.newStatus = null;
      this.$EventBus.$emit('ConnectionChangeStatus/UPDATE_CONNECTION_RECORD', updatedConnection);
      this.$store.dispatch('connections/getConnections');
    },
  },
};
